/**
 * Datadog Real User Monitoring (RUM) Integration
 *
 * Initializes Datadog RUM tracking with environment-aware configuration.
 * Loads the Datadog RUM agent and configures it based on the current environment.
 */

export default class DatadogRUM {
	constructor() {
		const analyticsConfig = window.analyticsConfig || {};
		this.environment = analyticsConfig.environment || 'development';
		this.isInitialized = false;
		this.init();
	}

	init() {
		if (this.isInitialized) {
			return;
		}

		if (!this.environment) {
			// eslint-disable-next-line no-console
			console.warn('Datadog RUM: No environment configuration found');
			return;
		}

		this.loadDatadogScript();
	}

	loadDatadogScript() {
		(function (h, o, u, n, d) {
			h = h[d] = h[d] || {
				q: [],
				onReady(c) {
					h.q.push(c);
				},
			};
			d = o.createElement(u);
			d.async = 1;
			d.src = n;
			n = o.getElementsByTagName(u)[0];
			n.parentNode.insertBefore(d, n);
		})(
			window,
			document,
			'script',
			'https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js',
			'DD_RUM',
		);

		window.DD_RUM.onReady(() => {
			this.initializeRUM();
		});
	}

	initializeRUM() {
		try {
			window.DD_RUM.init({
				clientToken: 'pubd775724ee6e02ad68aa80be625b421d5',
				applicationId: '46167f11-e6da-49e6-b22f-cb9fb02127e2',
				site: 'datadoghq.com',
				service: 'grow',
				env: this.environment,
				sessionSampleRate: 1,
				sessionReplaySampleRate: 0,
				trackUserInteractions: true,
				trackResources: true,
				trackLongTasks: true,
				defaultPrivacyLevel: 'mask-user-input',
			});

			this.isInitialized = true;
			// eslint-disable-next-line no-console
			console.log(
				`Datadog RUM initialized for environment: ${this.environment}`,
			);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Failed to initialize Datadog RUM:', error);
		}
	}
}
